import { createCustomMarketActivityUrl } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";
import { useRouterLocale } from "src/utils/router/use-router-locale";

interface IRequest {
    activity: string;
    value: string;
}

/**
 * sends a post request to umbraco to trigger the creation of a new marketo activity
 */
export const useCustomActivityMutation = () => {
    const { language, country } = useRouterLocale();

    const { mutatePromise } = useMutation<void, void, IRequest>(createCustomMarketActivityUrl(language, country));
    return mutatePromise;
};
